export const siteConfig = {
  domain: 'https://concept13.ru',
  brand: 'Концепт 13',
  legalName: 'ООО «Концепт 13»',
  tagline: 'Двигатели и агрегаты для грузовиков и спецтехники',
  ogImage: '/og-image.jpg',
  formEndpoint: '', // подключить реальный URL API после деплоя
};

export type Contacts = typeof contacts;
export const contacts = {
  legalName: 'ООО «Концепт 13»',
  address: {
    postalCode: '620072',
    city: 'Екатеринбург',
    street: 'ул. Высоцкого, 42/2, офис 401',
    full: '620072, г. Екатеринбург, ул. Высоцкого, 42/2, офис 401',
    yandexMapsQuery: 'Екатеринбург, ул. Высоцкого, 42/2',
    // [долгота, широта] — реальные координаты дома, взяты с yandex.ru/maps.
    // Используются в виджете для точного центрирования + пина.
    mapCoords: [60.694043, 56.840060] as [number, number],
  },
  phones: [
    { label: 'Офис', value: '+7 (343) 385-85-13', tel: '+73433858513' },
    { label: 'Мобильный', value: '+7 (922) 226-09-13', tel: '+79222260913' },
  ],
  email: 'concept13@list.ru',
  workingHours: 'Пн–Пт, 9:00–18:00 (УрФО)',
};

export const navItems = [
  { label: 'Агрегаты', href: '#products' },
  { label: 'Поставки', href: '#supplies' },
  { label: 'Как работаем', href: '#how' },
  { label: 'О компании', href: '#about' },
  { label: 'Контакты', href: '#contacts' },
];

/**
 * Юридические реквизиты ООО «КОНЦЕПТ13».
 * Только то, что официально опубликовано заказчиком.
 * Банковские реквизиты публичными не размещаем.
 */
export const companyDetails = {
  fullName: 'Общество с ограниченной ответственностью «КОНЦЕПТ13»',
  shortName: 'ООО «КОНЦЕПТ13»',
  legalAddress:
    '620092, Свердловская область, г. Екатеринбург, ул. Рассветная, д. 8, корп. 1, кв. 351',
  postalAddress:
    '620092, Свердловская область, г. Екатеринбург, ул. Рассветная, д. 8, корп. 1, кв. 351',
  inn: '6670519018',
  kpp: '667001001',
  ogrn: '1236600058221',
  email: 'concept13@list.ru',
  director: 'Шарипова Виктория Викторовна',
};

export const legalLastUpdated = '17 июня 2026 года';

/**
 * Дисклеймеры, которые встречаются и в футере, и рядом с ценами.
 */
export const disclaimers = {
  publicOffer:
    'Информация, размещённая на сайте, носит справочный характер и не является публичной офертой. Цены, наличие, комплектация, сроки поставки, условия гарантии, рассрочки и оплаты подтверждаются представителем ООО «КОНЦЕПТ13» перед заключением договора.',
  price:
    'Цена и условия поставки подтверждаются на дату обращения.',
  formSubmit:
    'Нажимая кнопку, вы подтверждаете достоверность переданных данных и соглашаетесь на их обработку для подготовки ответа и коммерческого предложения.',
};

/**
 * Ссылки на юридические документы. Используются в футере, в FormConsent
 * и в cookie-баннере. Если URL поменяются — правьте здесь в одном месте.
 */
export const legalLinks = [
  { href: '/privacy-policy', label: 'Политика обработки персональных данных' },
  { href: '/personal-data-consent', label: 'Согласие на обработку персональных данных' },
  { href: '/cookie-policy', label: 'Политика использования файлов cookie' },
  { href: '/terms', label: 'Пользовательское соглашение' },
  { href: '/company-details', label: 'Реквизиты компании' },
];
